export const LOADING_EMAILTEMPLATE = "LOADING_EMAILTEMPLATE";
export const GET_EMAILTEMPLATE_LIST = "GET_EMAILTEMPLATE_LIST";
export const REMOVE_EMAILTEMPLATE = "REMOVE_EMAILTEMPLATE";
export const ADD_EMAILTEMPLATE = "ADD_EMAILTEMPLATE";
export const UPDATE_EMAILTEMPLATE = "UPDATE_EMAILTEMPLATE";
export const GET_EMAILTEMPLATEID = "GET_EMAILTEMPLATEID";


export const GET_PLATFORM_TYPE = "GET_PLATFORM_TYPE";
export const ADD_CONTENT_TEMPLATE = "ADD_CONTENT_TEMPLATE";
export const GET_CONTENT_TEMPLATE = "GET_CONTENT_TEMPLATE";
export const GET_CONTENT_TEMPLATE_BY_ID = "GET_CONTENT_TEMPLATE_BY_ID";
export const UPDATE_CONTENT_TEMPLATE = "UPDATE_CONTENT_TEMPLATE";
export const DELETE_CONTENT_TEMPLATE = "DELETE_CONTENT_TEMPLATE";